import { render, staticRenderFns } from "./CreateRoom.vue?vue&type=template&id=a222dd74&scoped=true"
import script from "./CreateRoom.vue?vue&type=script&lang=js"
export * from "./CreateRoom.vue?vue&type=script&lang=js"
import style0 from "./CreateRoom.vue?vue&type=style&index=0&id=a222dd74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a222dd74",
  null
  
)

export default component.exports